/* eslint-disable */
import api from '@/services/api';

export default {
  openModalPatchNotes({ commit }) {
    commit('SET_OPEN_MODAL', true);
  },
  closeModalPatchNotes({ commit }) {
    commit('SET_OPEN_MODAL', false);
  },
  async fetchPatchNotes({ commit }) {
    const response = await api.get('/patch-notes');
    commit('SET_PATCH_NOTES', response.data);
  }
};
